import { PlusIcon } from 'lucide-react'
import { forwardRef } from 'react'

import { Button } from '@/components'
import { cn } from '@/utils'

interface AddFilterTriggerProps {
  onClick?: () => void
  className?: string
}

export const AddFilterTrigger = forwardRef<
  HTMLButtonElement,
  AddFilterTriggerProps
>(({ onClick, className, ...props }, ref) => {
  return (
    <Button
      theme="outline"
      size="sm"
      className={cn('h-8 gap-1 font-normal', className)}
      onClick={onClick}
      {...props}
      ref={ref}
    >
      <PlusIcon className="size-4" />
      Add Filter
    </Button>
  )
})
